
// import route from 'ziggy';
import { Ziggy } from './ziggy';
window.Swal = require('sweetalert2');
import { formatUtcToLocal } from '@/helpers/date';


export const mixin = {

    created() {
        //   this.hello()
    },
    methods: {
        $has(..._roles) {
            return this.$page.props._roles?.some(role => role == _roles);
        },
        $can(..._permissions) {
            return this.$page.props._permissions?.some(permission => permission == _permissions);
        },
        formatToCurrency: function (amount) {
            return (amount).toFixed(3).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
        formatMoney: function (value, currency = "LYD") {
            // return this.formatToCurrency(value) + " " + currency;
            return `${this.formatToCurrency(value)} ` + this.__(`app.currency.${currency}`)
        },
        intlFormat: function(){
            return  new Intl.NumberFormat();
        },
        asset(path) {
            var base_path = window._asset || '';
            return base_path + path;
        },
        route($name, $parameter) {
            return route($name, $parameter);
        },
        swal(message, type) {
            return Swal.fire({
                icon: type,
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        },
        swalAlert(message, title, type) {
            return Swal.fire({
                icon: type,
                title: title,
                text: message,
            })
        },
        __(key, replace) {
            let translation, translationNotFound = true

            try {
                translation = key.split('.').reduce((t, i) => t[i] || null, window._translations[window._locale].php)

                if (translation) {
                    translationNotFound = false
                }
            } catch (e) {
                translation = key
            }

            if (translationNotFound) {
                translation = window._translations[window._locale]['json'][key]
                    ? window._translations[window._locale]['json'][key]
                    : key
            }

            _.forEach(replace, (value, key) => {
                translation = translation.replace(':' + key, value)
            })

            return translation
        },
        getQueryParam(name) {
            if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
                return decodeURIComponent(name[1]);
        },
        bShowModal(id) {
            $(`#${id}`).modal('show')
        },
        $localDate(date) {
            return formatUtcToLocal(date);
        }
    }
}
